// EXEC-target slot detector (Workstream C, mssql 41.§2 / 37.§1-§2).
//
// The clause machine has no EXEC arm, so `EXEC ▮` classifies as unknown and
// the fallback emitted tables — but the only legal completions there are
// stored procedures (plus schemas to qualify them). Same text-walk shape as
// `isAtInsertTargetSlot`: matches when the caret sits after `EXEC`/`EXECUTE`
// with at most a partial identifier — `EXEC ▮`, `EXECUTE ▮`,
// `EXEC dbo.acact_Ge▮`. Does NOT match once the target is complete and the
// argument list has started (`EXEC sp_executesql @sql, ▮`, `EXEC ('…')▮`) or
// inside `EXECUTE AS …` impersonation clauses.

import { stripCommentsPreserving } from './sqlClauseToPositionKind';

// Tail = EXEC[UTE] followed only by an optional in-progress identifier
// (schema-qualified, [bracketed], "quoted", # for temp procs). `EXECUTE AS`
// is excluded via the negative lookahead on the ident part.
const EXEC_TARGET_TAIL_RE =
  /\bEXEC(?:UTE)?\s+(?!AS\b)(?:#{0,2}[A-Za-z_["][\w.$#[\]"]*)?$/i;

export function isAtExecTargetSlot(
  text: string,
  offset: number,
  statementStart: number,
): boolean {
  const slice = stripCommentsPreserving(text.slice(statementStart, offset));
  return EXEC_TARGET_TAIL_RE.test(slice);
}
